import { Injectable } from '@angular/core';

import { FEATURE_INTERACTIONS_STORAGE_KEY } from '../constants';
import type { FeatureInteractions } from '../models';

@Injectable({ providedIn: 'root' })
export class FeatureInteractionStorageService {
  loadFeatureInteractionsFromLocalStorage(): FeatureInteractions {
    try {
      const stored = localStorage.getItem(FEATURE_INTERACTIONS_STORAGE_KEY);

      if (!stored) {
        return {};
      }

      const parsed: unknown = JSON.parse(stored);

      return this.isFeatureInteractions(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }

  saveFeatureInteractionsToLocalStorage(
    interactions: FeatureInteractions,
  ): void {
    try {
      return localStorage.setItem(
        FEATURE_INTERACTIONS_STORAGE_KEY,
        JSON.stringify(interactions),
      );
    } catch {
      return undefined;
    }
  }

  private isFeatureInteractions(value: unknown): value is FeatureInteractions {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return false;
    }

    return Object.entries(value).every(([featureKey, interaction]) => {
      if (
        !featureKey.trim() ||
        !interaction ||
        typeof interaction !== 'object' ||
        Array.isArray(interaction)
      ) {
        return false;
      }

      const entry = interaction as Record<string, unknown>;

      return (
        typeof entry['seenAt'] === 'string' &&
        Number.isFinite(Date.parse(entry['seenAt'])) &&
        typeof entry['tourCompleted'] === 'boolean'
      );
    });
  }
}
